import React from 'react';
import { Spinner } from '../Common';

export default class SendEmailForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            errorMessage: ''
        }
    }

    onEmailChange = (e) => {
        const email = e.target.value;
        this.setState(() => ({ email }));
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.sendEmail({
            email: this.state.email,
            hostWebsite: window.location.origin
        })
    }

    render() {
        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <label >Veuillez entrer votre adresse e-mail et vous recevrez des instructions à suivre.</label>
                        <input
                            type="text"
                            className="form-control"
                            //placeholder="Enter email"
                            autoFocus
                            value={this.state.email}
                            onChange={this.onEmailChange}
                        />
                    </div>

                    <div className="required-txt"> * Champs obligatoires</div>
                    <div className="button-container">
                        <button type="submit" className={`btn btn-primary btn-lg spinner-${this.props.spinner}`} disabled={!this.state.email} >
                            <span>ENVOYER</span>
                            <Spinner status={this.props.spinner} />
                        </button>
                    </div>
                </form>
                <div className="bloc-form_error">
                    {this.state.errorMessage &&
                        <div className="alert alert-danger" role="alert">
                            {this.state.errorMessage}
                        </div>
                    }
                </div>
            </div>
        )
    }

}





// WEBPACK FOOTER //
// ./src/components/LoginPage/SendEmailForm.js